import React from "react";
import { css } from "styled-components";
import {
  SUCCESS_50,
  GREEN_DARK3,
  STRONG_GREEN,
  DISABLED_GREEN,
  PRIMARY_400,
  PRIMARY_650,
  PRIMARY_600,
  PRIMARY_800,
  WHITE,
  LIGHT_GREEN
} from "../../constant/colors";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Space, Typography } from "antd";
const { Text } = Typography;
import ElectricityIcon from "../../assets/svg/electricity";
import { fontWeights, sizes } from "../../constant/styles";

export const ExpressEnrolmentBrandContainer = css`
  background-color: ${SUCCESS_50};
  border-color: ${LIGHT_GREEN};
  border-radius: 8px;
`;

export const ExpressEnrolmentBrandContainerWithBorder = css`
  ${ExpressEnrolmentBrandContainer}
  border-style: solid;
  border-width: 1px;
  padding: 16px;
`;

export const ExpressEnrollmentBrandText = css`
  color: ${GREEN_DARK3} !important;
`;

export const ExpressEnrollmentLightText = css`
  color: ${STRONG_GREEN} !important;
`;

export const ExpressEnrollmentButton = css`
  background-color: ${GREEN_DARK3} !important;
  border: 1px solid ${GREEN_DARK3} !important;
`;

export const ExpressEnrollmentButtonDisabled = css`
  background-color: ${DISABLED_GREEN} !important;
  border: 1px solid ${DISABLED_GREEN} !important;
`;

export const ExpressEnrollButton = styled(Button)`
  ${ExpressEnrollmentButton}
  border: 1px solid ${PRIMARY_650};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 4px;
  background: ${PRIMARY_600};
  color: ${WHITE};
  font-style: normal;
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.medium};

  &:hover {
    background: ${PRIMARY_800};
    border: 1px solid ${PRIMARY_600};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 4px;
    color: ${WHITE};
  }

  :active {
    background: ${PRIMARY_600};
    border: 4px solid ${PRIMARY_400};
    border-radius: 4px;
    color: ${WHITE};
    padding-top: 1px;
  }

  :disabled {
    background: ${PRIMARY_600};
    opacity: 0.3;
    border: 1px solid ${PRIMARY_600};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 4px;
    color: ${WHITE};
  }
`;

const ExpressEnrollmentBrandTextComponent = styled(Text)`
  font-weight: ${fontWeights.semibold};
  ${ExpressEnrollmentBrandText}
`;

export const SupportsExpressEnrollmentText = ({ style, id }) => {
  const { t } = useTranslation();
  const baseText = t("express_enroll.supports_express_enroll");

  return (
    <Space direction="horizontal" size={5} style={{ alignItems: "flex-start" }}>
      <ElectricityIcon color={GREEN_DARK3} />
      <ExpressEnrollmentBrandTextComponent style={{ ...style }} id={id}>
        {baseText}
      </ExpressEnrollmentBrandTextComponent>
    </Space>
  );
};
